module.exports = __webpack_public_path__ + "static/media/website-10.64c76c64.png";